import {alpha, CardActions, CardContent, CardMedia, Divider, Grid, Skeleton} from "@mui/material";
import Typography from "@mui/material/Typography";
import Card from "@mui/material/Card/Card";
import {getRandomNumber} from "../../../../../util/utils";
import * as React from "react";
import {useTheme} from "@mui/material/styles";

const WishGridItemSkeleton = () => {
    const theme = useTheme()
    return (
        <Card elevation={3} sx={{
            width: {xs: '90%', sm: 265},
            backgroundColor: "transparent",
            border: `1px solid ${theme.palette.primary.main}`,
            my: 2,
            mx: 0.8,
        }}>
            <CardMedia component='div'>
                <Skeleton animation='pulse' variant='rectangular' height='150px'/>
            </CardMedia>

            <CardContent sx={{p: 1}}>
                <Typography justifyItems='center' variant="h5" sx={{fontSize: '1.2rem'}}>
                    <Skeleton width={`100%`} animation='wave'/>
                    <Skeleton width={`${getRandomNumber(80, 90)}%`} animation='wave'/>
                </Typography>
                <Typography variant="body2" display='flex' justifyContent='center' color="text.secondary">
                    <Skeleton width={`${getRandomNumber(30, 60)}%`} animation='wave'/>
                </Typography>
                <Divider sx={{
                    backgroundColor: alpha(theme.palette.primary.main, .6), my: 1
                }}/>
                <Grid container justifyContent="space-between" sx={{mt: 1}}>
                    <Skeleton variant='rectangular' width={120} height={25}/>
                    <Skeleton variant='rectangular' width={50} height={25}/>
                </Grid>
                <Divider sx={{
                    backgroundColor: alpha(theme.palette.primary.main, .6), my: 1
                }}/>
                <Skeleton variant='rectangular' height={90} sx={{mt: 2}}/>
            </CardContent>
            <CardActions sx={{p: 0, px: 1, pb: 1}}>
                <Skeleton variant='rectangular' height={35} width="100%"/>
            </CardActions>
        </Card>
    )
}
export default WishGridItemSkeleton
